import { useState, useEffect } from "react";
import TextArea from "../ReusableComponents/TextArea";
import InputText from "../ReusableComponents/InputText";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import { mainTable } from "../css/Common";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import { ReceiptsHeaders } from "../components/HeaderAttribute";
import ReceiptMainPopup from "../popup-containers/ReceiptMainPopup";
import Receiptpopup from "../popup-containers/Receiptpopup";
import { BindPostAPI, IUDAPI } from "../services/APIConnection";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import toast from "react-hot-toast";
import PopUpButtons from "../components/PopUpButtons";
import { format } from "date-fns";
import UsePrevious from "../Hook/UsePrevious";
import Loader from "../ReusableComponents/Loader";
import ErrorPopup from "../ReusableComponents/ErrorPopup";

const Receipts = () => {
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [submitBtnDisabled, setsubmitBtnDisabled] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setupdateScreenTitle] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [bindreceiptsData, setBindReceiptsData] = useState([]);

  const [receiptData, setReceiptData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const createdBy = sessionStorage.getItem("createdBy");
  const mstclientId = sessionStorage.getItem("MstClientId");
  const [errors, setErrors] = useState({
    receiptno: "",
    receiptdate: "",
    receivedFrom: "",
    receivedBy: "",
    remarks: "",
  });
  const headerData = [
    {
      title: "Item Type",
      key: "itemType",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Category",
      key: "commoditiesCategory",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Name",
      key: "commoditiesName",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Quantity",
      key: "quantity",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "U.O.M.",
      key: "uom",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Rate",
      key: "rate",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Action",
      key: "Action",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
  ];
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [receiptError, setReceiptError] = useState("");
  const [commoditiesDetails, setCommoditiesDetails] = useState("");

  const [popUpData, setPopUpData] = useState({});
  const [popUpDataDD, setPopUpDataDD] = useState({});
  const [itemTypeDropdown, setItemTypeDropdown] = useState([]);
  const [categoryDropdown, setCategoryDropdown] = useState([]);
  const [itemNameDropdown, setItemNameDropdown] = useState([]);

  const [formFields, setFormFields] = useState({
    receiptno: "REC",
    receiptdate: "",
    receivedFrom: "",
    receivedBy: "",
    remarks: "",
  });

  const [formFieldsError, setFormFieldsError] = useState({
    receiptno: "",
    receiptdate: "",
    receivedFrom: "",
    receivedBy: "",
    remarks: "",
  });

  const [mstReceiptId, setMstReceiptId] = useState("");

  const [tableData, setTableData] = useState([
    {
      itemType: "",
      itemCategoryId: "",
      itemId: "",
      quantity: "",
      rate: "",
      uom: "",
      itemList: [], // filtered item list per row
      itemCategoryList: [],
    },
  ]);

  const [receiptChildData, setReceiptChildData] = useState([]);

  useEffect(() => {
    BindReceipt();
  }, []);

  const BindReceipt = async () => {
    try {
      setIsLoading(true);

      const requestData = {
        mstClientId: mstclientId,
      };

      const response = await BindPostAPI(requestData, "ReceiptAPI/BindReceipt");

      if (response && response.data) {
        const data = response.data;
        console.log("BindResposne", response);

        // Grid data
        setBindReceiptsData(data?.Table || []);

        // Dropdowns
        const itemTypeOptions = (data?.Table1 || []).map((item) => ({
          value: item.MstItemTypeId,
          label: item.ItemType,
        }));
        setItemTypeDropdown(itemTypeOptions);

        const categoryOptions = (data?.Table2 || []).map((item) => ({
          value: item.MstItemCategoryId,
          label: item.ItemCategory,
        }));
        setCategoryDropdown(data?.Table2);

        const itemNameOptions = (data?.Table3 || []).map((item) => ({
          value: item.MstItemId,
          label: item.ItemName,
        }));
        setItemNameDropdown(data?.Table3);
        setReceiptChildData(response.data.Table4);
        setBindReceiptChildData(response.data.Table4);
      } else {
        console.error("BindReceipt: Invalid response", response);
      }
    } catch (error) {
      console.error("BindReceipt Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = (rowIndex) => {
    const selectedRow = bindreceiptsData[rowIndex];
    if (!selectedRow) return;

    const selectedTxnId = selectedRow.TxnReceiptId;

    const relatedRows = bindreceiptsData.filter(
      (row) => row.TxnReceiptId === selectedTxnId
    );

    setupdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setMstReceiptId(selectedRow.TxnReceiptId);
    const formatted = bindreceiptsData[rowIndex]?.ReceiptDate
      ? format(new Date(bindreceiptsData[rowIndex].ReceiptDate), "yyyy-MM-dd")
      : "";

    setFormFields({
      ...formFields,
      mstReceiptId: selectedRow.TxnReceiptId,
      receiptno: selectedRow.ReceiptNo,
      receiptdate: formatted,
      receivedFrom: selectedRow.ReceivedFrom,
      receivedBy: selectedRow.ReceivedBy,
      remarks: selectedRow.Remarks,
    });

    const TesttxnReceiptId = bindreceiptsData[rowIndex].TxnReceiptId;

    if (!TesttxnReceiptId) {
      console.error("TxnIssueId not found");
      return;
    }

    const filtered = receiptChildData.filter(
      (item1) => item1?.TxnReceiptId === TesttxnReceiptId
    );

    if (filtered.length === 0) {
      setTableData([
        {
          itemType: "",
          itemCategoryId: "",
          itemId: "",
          uom: "",
          quantity: "",
          rate: "",
          itemCategoryList: [],
          itemList: [],
          currentStock: "",
          currentQty: "",
          currentDelete: "",
        },
      ]);
    } else {
      // Append the filtered data to your state using appendDataToState function
      appendDataToConsumeTable(JSON.stringify(filtered));
    }
  };

  const appendDataToConsumeTable = (newDataString) => {
    const newDataArray = JSON.parse(newDataString);
    handleDeleteRow(0);
    setTableData([]);
    const formattedDataArray = newDataArray.map((data) => {
      return {
        itemType: data.MstItemTypeId,
        itemCategoryId: data.MstCategoryId,
        itemId: parseInt(data.MstNameId, 10),
        rate: data.Rate,
        uom: data.UOM,
        quantity: data.Quantity,
        currentQty: data.Quantity,
      };
    });

    setTableData((prevData) => [...prevData, ...formattedDataArray]);
    updateTableData(formattedDataArray);
    convertArrayToJSONString(formattedDataArray);
  };

  const convertArrayToJSONString = (array) => {
    try {
      const jsonString = JSON.stringify(array);
      setCommoditiesDetails(jsonString);
      return jsonString;
    } catch (error) {
      console.error("Error converting array to JSON string:", error);
      return null;
    }
  };

  const previousTableData = UsePrevious(tableData);
  useEffect(() => {
    updateTableData();
  }, [tableData]);

  const updateTableData = async () => {
    if (JSON.stringify(previousTableData) !== JSON.stringify(tableData)) {
      const updatedTableData = [...tableData];
      console.log(updateTableData);
      console.log("itemcategory", categoryDropdown);

      for (const row of updatedTableData) {
        // Update itemCategoryList if itemtype is selected
        if (row?.itemType) {
          const filteredCategories = categoryDropdown
            .filter((item) => item.MstItemTypeId == row.itemType)
            .map((item) => ({
              value: item.MstItemCategoryId,
              label: item.ItemCategory,
            }));
          row.itemCategoryList = filteredCategories;
          console.log(row.itemCategoryList);
        }

        // Update itemList and uom if itemcategory is selected
        if (row?.itemCategoryId) {
          const filteredItems = itemNameDropdown

            .filter((item) => item.MstItemCategoryId === row.itemCategoryId)
            .map((item) => ({
              value: item.MstItemId,
              label: item.ItemName,
              uom: item.UOM,
            }));
          row.itemList = filteredItems;
          console.log(row.itemList);

          const selectedItem = filteredItems.find(
            (item) => item.value === row.itemId
          );
          row.uom = selectedItem?.uom || "";
        }
        if (row?.itemId) {
          const data = {
            mstClientId: parseInt(mstclientId || 0),
            mstItemTypeId: parseInt(row.itemType || 0),
            mstCategoryId: parseInt(row.itemCategoryId || 0),
            mstNameId: parseInt(row.itemId || 0),
          };

          try {
            const response = await BindPostAPI(
              data,
              "ReceiptAPI/BindAvailableStock"
            );

            const remainingQty =
              Number(response?.data?.Table?.[0]?.RemainingQuantity) || 0;

            // ✅ USE DIRECTLY
            row.currentStock = remainingQty;
            row.currentDelete = remainingQty;
          } catch (error) {
            console.error("Error fetching current stock:", error);
            row.currentStock = 0;
            row.currentDelete = 0;
          }
        }
      }

      setTableData(updatedTableData);
    }
  };
  // const updateTableData1 = async () => {
  //   if (JSON.stringify(previousTableData) !== JSON.stringify(tableData)) {
  //     const updatedTableData = [...tableData];
  //     console.log(updateTableData);
  //     console.log("itemcategory", categoryDropdown);

  //     for (const row of updatedTableData) {
  //       // Update itemCategoryList if itemtype is selected
  //       if (row?.itemType) {
  //         const filteredCategories = categoryDropdown
  //           .filter((item) => item.MstItemTypeId === row.itemType)
  //           .map((item) => ({
  //             value: item.MstItemCategoryId,
  //             label: item.ItemCategory,
  //           }));
  //         row.itemCategoryList = filteredCategories;
  //         console.log(row.itemCategoryList);
  //       }

  //       // Update itemList and uom if itemcategory is selected
  //       if (row?.itemCategoryId) {
  //         const filteredItems = itemNameDropdown

  //           .filter((item) => item.MstItemCategoryId === row.itemCategoryId)
  //           .map((item) => ({
  //             value: item.MstItemId,
  //             label: item.ItemName,
  //             uom: item.UOM,
  //           }));
  //         row.itemList = filteredItems;
  //         console.log(row.itemList);

  //         const selectedItem = filteredItems.find(
  //           (item) => item.value === row.itemId
  //         );
  //         // row.uom ="";
  //         // row.uom = selectedItem?.uom || '';
  //       }
  //     }

  //     setTableData(updatedTableData);
  //   }
  // };

  const [bindreceiptChildData, setBindReceiptChildData] = useState([]);
  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setupdateScreenTitle(false);
    setAddScreenTitle(true);
  };

  const handleReceipt = (rowIndex, flag) => {
    setpopUpOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }
    setReceiptData(bindreceiptsData[rowIndex]);
    setFormFields({
      ...formFields,
      mstReceiptId: bindreceiptsData[rowIndex].TxnReceiptId,
    });

    const rowData = bindreceiptsData[rowIndex];

    setPopUpData(rowData); // For master fields

    const TesttxnReceiptId = bindreceiptsData[rowIndex].TxnReceiptId;

    const filtered = bindreceiptChildData.filter(
      (item) => item && String(item.TxnReceiptId) === String(TesttxnReceiptId)
    );
    setPopUpDataDD(filtered);
  };

  const cancel = () => {
    BindReceipt();
    setVisibleAdd(false);
    setVisibleTable(true);
    setAddScreenTitle(false);
    setupdateScreenTitle(false);
    setIsLoading(false);
    setpopUpOpen(false);
    setPopUpViewOpen(false);
    setCommoditiesDetails("");
    setReceiptError("");
    setFormFields({
      receiptno: "REC",
      receiptdate: "",
      receivedFrom: "",
      receivedBy: "",
      remarks: "",
    });

    setFormFieldsError({});
    setErrors({
      receiptno: "",
      receiptdate: "",
      receivedFrom: "",
      receivedBy: "",
      remarks: "",
    });
    setTableData([
      {
        itemType: "",
        itemCategoryId: "",
        itemId: "",
        quantity: "",
        rate: "",
        uom: "",
        itemCategoryList: [],
        itemList: [],
      },
    ]);
    setIsLoading(false);
    setsubmitBtnDisabled(false);
    setIsOpen(false);

    console.log("Form cancelled and reset");
  };

  const handleInputChangeForm = (e) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({ ...prev, [name]: value }));
  };

  const [popUpViewOpen, setPopUpViewOpen] = useState(false);
  const [receiptRecord, setReceiptRecord] = useState([]);
  const [receiptTableData, setReceiptTableData] = useState([]);
  const showView = (rowIndex, flag) => {
    setPopUpViewOpen(true);

    const rowdata = bindreceiptsData[rowIndex];
    //setmainconsumeRecord(rowdata);
    setReceiptRecord(rowdata);

    const TesttxnReceiptId = bindreceiptsData[rowIndex].TxnReceiptId;

    // Step 1: Filter data for this enquiry
    const filtered = receiptChildData.filter(
      (item) => item && String(item.TxnReceiptId) === String(TesttxnReceiptId)
    );

    setReceiptTableData(filtered);
  };
  const handleInputChangeTable = (selectedOption, rowIndex, columnName) => {
    const value = selectedOption ? selectedOption.value : "";
    setTableData((prevTableData) => {
      const updatedData = [...prevTableData];
      updatedData[rowIndex] = { ...updatedData[rowIndex], [columnName]: value };
      convertArrayToJSONString(updatedData);
      return updatedData;
    });
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const newErrors = { ...errors };
    if (!value) {
      newErrors[name] = "This field is required";
    } else {
      delete newErrors[name];
    }
    setErrors(newErrors);
  };

  const handleDeleteRow = (index) => {
    setTableData((prevData) => {
      const updatedTableData = prevData.filter((_, i) => i !== index);

      if (updatedTableData.length === 0) {
        const newRow = {
          itemType: "",
          itemCategoryId: "",
          itemId: "",
          quantity: "",
          rate: "",
          uom: "",
          itemCategoryList: [],
          itemList: [],
        };
        return [newRow];
      }

      return updatedTableData;
    });
  };

  const handleAddRow = () => {
    if (tableData.length >= 4) {
      toast.error("Cannot add more than 4 rows.");
      return;
    }

    // Get the last row's itemCategoryId and itemId (if applicable)
    const lastRow = tableData[tableData.length - 1];

    // Check if the last row has both itemCategoryId and itemId selected
    if (lastRow && lastRow.itemCategoryId && lastRow.itemId) {
      // Check for duplicates in tableData
      const isDuplicate = tableData.some(
        (row, index) =>
          index !== tableData.length - 1 && // Exclude the last row itself
          row.itemType === lastRow.itemType &&
          row.itemCategoryId === lastRow.itemCategoryId &&
          row.itemId === lastRow.itemId
      );
      if (isDuplicate) {
        toast.error("Item with the same category and name already exists.");
        return;
      }
    } else {
      // Optionally, you can add a check to ensure itemCategoryId and itemId are selected
      toast.error(
        "Please select both Item Category and Item Name before adding a new row."
      );
      return;
    }

    // Add new row if validation passes
    setTableData([
      ...tableData,
      {
        itemType: "",
        itemCategoryId: "",
        itemId: "",
        quantity: "",
        rate: "",
        uom: "",
        itemCategoryList: [],
        itemList: [],
      },
    ]);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (items, flag) => {
    try {
      setsubmitBtnDisabled(true);
      setIsLoading(true);

      if (flag === 1 || flag === 2) {
        // Validation
        const newErrors = {
          receiptno: formFields.receiptno ? "" : "Enter Receipt No",
          receiptdate: formFields.receiptdate ? "" : "Enter Receipt Date",
          receivedFrom: formFields.receivedFrom ? "" : "Enter Received From",
          receivedBy: formFields.receivedBy ? "" : "Enter Received By",
        };
        setErrors(newErrors);

        if (commoditiesDetails.trim() === "") {
          setReceiptError("Fill the above table");
          setsubmitBtnDisabled(false);
          setIsLoading(false);
          setIsOpen(true);
          return; // Stop further execution
        }

        let receiptData;
        try {
          receiptData = JSON.parse(commoditiesDetails);
        } catch (error) {
          console.error("Error parsing receipt data:", error);
          setReceiptError("Error parsing receipt data");
          return; // Stop further execution
        }

        if (!Array.isArray(receiptData)) {
          console.error("Receipt data is not an array");
          setReceiptError("Receipt data is not an array");
          return; // Stop further execution
        }
        console.log("receiptData", receiptData);
        const receiptErrors = receiptData.map((receipt, index) => {
          if (!receipt) return `Receipt at index ${index + 1} is missing.`;
          if (!receipt.itemType)
            return `Receipt at index ${index + 1} is missing Item Type.`;
          if (!receipt.itemCategoryId)
            return `Receipt at row ${index + 1} is missing Category.`;
          if (!receipt.itemId)
            return `Receipt at row ${index + 1} is missing Name.`;
          if (!receipt.quantity)
            return `Receipt at row ${index + 1} is missing Quantity.`;
          if (!receipt.rate)
            return `Receipt at row ${index + 1} is missing Rate.`;
          return null;
        });

        const filteredErrors = receiptErrors.filter((error) => error !== null);
        let inventoryReceiptChildValidation;
        if (filteredErrors.length > 0) {
          inventoryReceiptChildValidation = 1;
          setReceiptError(filteredErrors.join("; "));
          setsubmitBtnDisabled(false);
          setIsLoading(false);
          return; // Stop further execution
        } else {
          setReceiptError(""); // No errors found
          inventoryReceiptChildValidation = 0;
        }
        const isFormValid = Object.values(newErrors).every((err) => err === "");
        if (!isFormValid) {
          setsubmitBtnDisabled(false);
          setIsLoading(false);
          toast.error("Please enter all mandatory fields.");
          return;
        }

        // Format date
        //const formattedDate = `${formFields.receiptdate} 00:00:00`;

        // Prepare payload
        const payload = {
          mstClientId: mstclientId,
          txnReceiptId: formFields.mstReceiptId ? formFields.mstReceiptId : 0,
          receiptNo: formFields.receiptno,
          receiptdate: formFields.receiptdate || "",
          receivedFrom: formFields.receivedFrom,
          receivedBy: formFields.receivedBy,
          remarks: formFields.remarks,
          createdBy: parseInt(createdBy),
          flag: flag,
          receipt: JSON.stringify(
            tableData.map((row) => ({
              itemType: row.itemType,
              itemCategoryId: row.itemCategoryId,
              itemId: row.itemId,
              uomId: row.uom,
              quantity: row.quantity,
              rate: row.rate,
            }))
          ),
        };

        console.log("Payload =>", payload);

        const response = await IUDAPI(payload, "ReceiptAPI/IUDReceipt");
        const result = response?.data?.Table?.[0]?.Result;
        console.log("API Response =>", response);
        if (flag === 1 && result === "S") {
          toast.success("Receipt Added Successfully 👍");
        } else if (flag === 2 && result === "M") {
          toast.success("Receipt Updated Successfully 👍");
        } else {
          toast.error("Failed to save Receipt 👎");
        }
      } else {
        const data = {
          mstReceiptId: formFields.mstReceiptId,
          createdby: parseInt(createdBy),
          flag,
        };
        const response = await IUDAPI(data, "ReceiptAPI/IUDReceipt");
        const result = response?.data?.Table?.[0]?.Result;

        if (flag === 3 && result === "D") {
          toast.success("Deleted successfully 🗑️");
        } else if (flag === 4 && result === "B") {
          toast.success("Inactivated successfully 🚫");
        } else if (flag === 5 && result === "UB") {
          toast.success("Activated successfully ✅");
        } else {
          toast.error("Operation failed 👎");
        }
      }

      setTimeout(cancel, 1000);
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      toast.error("Something went wrong 👎");
    } finally {
    }
  };

  return (
    <MainLayout pageName={"3"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Receipts"
          header={ReceiptsHeaders}
          records={bindreceiptsData}
          blockView={true}
          handleEdit={handleEdit}
          handleAction={handleReceipt}
          showAdd={showAdd}
          onLaundryIssueView={showView}
        />
      )}

      {visibleAdd && (
        <div className="w-full">
          <div className={mainTable.clientMasterMainAdd}>
            <AddScreenTitle
              title="Receipts"
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
            />
          </div>
          <div className={mainTable.addShadowScreen}>
            <div className={mainTable.mainContentScreen}>
              <form onSubmit={handleSubmit}>
                <div className="grid gap-4 mb-4 md:grid-cols-4">
                  <InputText
                    title="Receipt No"
                    name="receiptno"
                    disabled={true}
                    content={formFields.receiptno}
                    classStar={"text-red-500"}
                    controlFunc={handleInputChangeForm}
                    controlFuncBlur={handleBlur}
                    errorMessage={errors.receiptno}
                  />
                  <InputText
                    inputType="date"
                    title="Receipt Date"
                    label="ReceiptDate"
                    name="receiptdate"
                    content={formFields.receiptdate}
                    classStar={"text-red-500"}
                    controlFunc={handleInputChangeForm}
                    controlFuncBlur={handleBlur}
                    errorMessage={errors.receiptdate}
                  />
                  <InputText
                    title="Received From"
                    type="text"
                    name="receivedFrom"
                    placeholder="Enter Name"
                    classStar={"text-red-500"}
                    content={formFields.receivedFrom}
                    controlFunc={handleInputChange}
                    controlFuncBlur={() => {
                      const value = formFields.receivedFrom?.trim() || "";
                      const regex = /^[A-Za-z\s\-]{2,}$/;
                      let error = "";

                      if (!value) {
                        error = "Enter Received From";
                      } else if (!regex.test(value)) {
                        error =
                          "Only letters, spaces, and hyphens (min 2 chars)";
                      }

                      setErrors((prev) => ({
                        ...prev,
                        receivedFrom: error,
                      }));
                    }}
                    errorMessage={errors.receivedFrom}
                  />

                  <InputText
                    title="Received By"
                    type="text"
                    name="receivedBy"
                    placeholder="Enter Name"
                    classStar={"text-red-500"}
                    content={formFields.receivedBy}
                    controlFunc={handleInputChange}
                    controlFuncBlur={() => {
                      const value = formFields.receivedBy?.trim() || "";
                      const regex = /^[A-Za-z\s\-]{2,}$/;
                      let error = "";

                      if (!value) {
                        error = "Enter Received By";
                      } else if (!regex.test(value)) {
                        error =
                          "Only letters, spaces, and hyphens (min 2 chars)";
                      }

                      setErrors((prev) => ({
                        ...prev,
                        receivedBy: error,
                      }));
                    }}
                    errorMessage={errors.receivedBy}
                  />
                </div>
                <div className="overflow-x-auto hidden md:block overflow-y-hidden">
                  <table className="min-w-full mb-2 table-auto border border-gray-300">
                    <thead className="bg-[#3D6643] overflow-x-auto text-white sticky top-0 z-10">
                      <tr>
                        <th className="border px-2 py-2 w-10 text-center">SN</th>
                        <th className="border px-4 py-2 min-w-[150px]">Item Type</th>
                        <th className="border px-4 py-2 min-w-[150px]">Category</th>
                        <th className="border px-4 py-2 min-w-[180px]">Name</th>
                        <th className="border px-4 py-2 w-[80px] text-center">Quantity</th>
                        <th className="border px-4 py-2 w-[90px] text-center">U.O.M</th>
                        <th className="border px-4 py-2 w-[90px] text-center">Rate</th>
                        <th className="border px-4 py-2 min-w-[100px]">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.map((row, index) => (
                        <tr key={index}>
                          <td className="border px-2 py-2">{index + 1}</td>
                          <td className="border px-4 py-2">
                            <AutoDropDown
                              name="itemType"
                              Class="custom-class"
                              options={itemTypeDropdown}
                              selectedOption={
                                row.itemType
                                  ? itemTypeDropdown.find(
                                    (x) => x.value === row.itemType
                                  )
                                  : ""
                              }
                              controlFunc={(e) =>
                                handleInputChangeTable(e, index, "itemType", true)
                              }
                              menuPortalTarget={document.body}
                            />
                          </td>
                          <td className="border px-4 py-2">
                            <AutoDropDown
                              name="itemCategoryId"
                              Class="custom-class"
                              options={row.itemCategoryList || []}
                              selectedOption={
                                (row.itemCategoryList &&
                                  row.itemCategoryList.find(
                                    (opt) => opt.value === row.itemCategoryId
                                  )) ||
                                null
                              }
                              controlFunc={(e) =>
                                handleInputChangeTable(
                                  e,
                                  index,
                                  "itemCategoryId",
                                  true
                                )
                              }
                              menuPortalTarget={document.body}
                            />
                          </td>
                          <td className="border px-4 py-2">
                            <AutoDropDown
                              name="itemId"
                              Class="custom-class"
                              options={row.itemList || []}
                              selectedOption={
                                (row.itemList &&
                                  row.itemList.find(
                                    (opt) => opt.value === row.itemId
                                  )) ||
                                null
                              }
                              content={row.itemId}
                              controlFunc={(e) =>
                                handleInputChangeTable(e, index, "itemId", true)
                              }
                              menuPortalTarget={document.body}
                            />
                          </td>

                          <td className="border px-4 py-2">
                            <div title={`Min Stock: ${row.currentStock || 0}`}>
                              <InputText
                                type="number"
                                name="quantity"
                                value={row.quantity}
                                content={row.quantity}
                                controlFunc={(e) => {
                                  const InputText = e.target.value;

                                  if (/^[0-9]*$/.test(InputText)) {
                                    handleInputChangeTable(
                                      e.target,
                                      index,
                                      "quantity"
                                    );
                                  }
                                }}
                                controlFuncBlur={(e) => {
                                  const inputValue = e.target.value;

                                  // Validate the value when the user leaves the field
                                  if (
                                    inputValue !== "" &&
                                    parseFloat(inputValue) <
                                    (row.currentStock || 0)
                                  ) {
                                    handleInputChangeTable(
                                      index,
                                      "quantity"
                                    ); // Clear the value if invalid
                                  }
                                }}
                              />
                            </div>
                          </td>
                          <td className="border px-4 py-2">
                            <InputText
                              name="uom"
                              content={row.uom}
                              controlFunc={(e) =>
                                handleInputChangeTable(e, index, "uom")
                              }
                            />
                          </td>
                          <td className="border px-4 py-2">
                            <InputText
                              type="number"
                              name="rate"
                              // value={row.rate}
                              content={row.rate}
                              controlFunc={(e) => {
                                const InputText = e.target.value;

                                if (/^[0-9]*$/.test(InputText)) {
                                  handleInputChangeTable(e.target, index, "rate");
                                }
                              }}
                            />
                          </td>
                          <td className="border px-4 py-2">
                            <div className="flex gap-4 items-center justify-center">
                              {addScreenTitle && (
                                <svg
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                  className="w-6 h-6 text-black cursor-pointer"
                                  onClick={() => handleDeleteRow(index)}
                                >
                                  <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                                </svg>
                              )}
                              {row.currentDelete >= row.quantity &&
                                updateScreenTitle && (
                                  <svg
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    className="w-6 h-6 text-black cursor-pointer"
                                    onClick={() => handleDeleteRow(index)}
                                  >
                                    <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                                  </svg>
                                )}

                              {index === tableData.length - 1 &&
                                tableData.length < 4 && (
                                  <svg
                                    viewBox="0 0 1024 1024"
                                    fill="currentColor"
                                    onClick={handleAddRow}
                                    className="w-6 h-6 text-black cursor-pointer"
                                  >
                                    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
                                  </svg>
                                )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="hidden md:block">
                  {receiptError && (
                    <div className="text-red-500 text-sm font-medium">
                      {receiptError}
                    </div>
                  )}
                </div>
                <div className={mainTable.tableMobile} role="table">
                  <div className="w-full md:overflow-y-auto lg:h-96 h-full">
                    {tableData.length > 0 &&
                      tableData.map((row, index) => (
                        <div scope="col" class={mainTable.mobileTable}>
                          {headerData.map((keyData) => (
                            <div
                              scope="cell"
                              class={mainTable.tableData}
                              role="cell"
                            >
                              {keyData.key === "Action" ? (
                                <div class={mainTable.tableData}>
                                  <div className="md:block hidden">
                                    <button
                                      id="dropdownMenuIconButton"
                                      data-dropdown-toggle="dropdownDots"
                                      class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none  focus:ring-gray-50 "
                                      type="button"
                                    >
                                      <svg
                                        class="w-6 h-6"
                                        aria-hidden="true"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                                      </svg>
                                    </button>
                                  </div>
                                  <div className="md:hidden flex justify-center">
                                    <input
                                      type="button"
                                      className="bg-[#3D6643] text-white mr-1 py-1 px-2 rounded-lg"
                                      onClick={handleAddRow}
                                      value="Add"
                                    />
                                    {addScreenTitle && (
                                      <input
                                        type="button"
                                        className="bg-[#3D6643] text-white mr-1 py-1 px-2 rounded-lg"
                                        onClick={() => handleDeleteRow(index)}
                                        value="Delete"
                                      />
                                    )}
                                    {row.currentDelete >= row.quantity &&
                                      updateScreenTitle && (
                                        <input
                                          type="button"
                                          className="bg-[#2d2d6e] text-white mr-1 py-1 px-2 rounded-lg"
                                          onClick={() => handleDeleteRow(index)}
                                          value="Delete"
                                        />
                                      )}
                                  </div>
                                </div>
                              ) : keyData.key === "itemType" ? (
                                <div className=" border p-1">
                                  <div className="flex items-center w-full font-bold">
                                    {keyData.title}
                                  </div>
                                  <AutoDropDown
                                    name="itemType"
                                    Class="custom-class"
                                    options={itemTypeDropdown}
                                    selectedOption={
                                      row.itemType
                                        ? itemTypeDropdown.find(
                                          (x) => x.value === row.itemType
                                        )
                                        : ""
                                    }
                                    controlFunc={(e) =>
                                      handleInputChangeTable(
                                        e,
                                        index,
                                        "itemType",
                                        true
                                      )
                                    }
                                  />
                                </div>
                              ) : keyData.key === "commoditiesCategory" ? (
                                <div className=" border p-1">
                                  <div className="flex items-center w-full font-bold">
                                    {keyData.title}
                                  </div>
                                  <AutoDropDown
                                    name="itemCategoryId"
                                    Class="custom-class"
                                    options={row.itemCategoryList || []}
                                    selectedOption={
                                      (row.itemCategoryList &&
                                        row.itemCategoryList.find(
                                          (opt) =>
                                            opt.value === row.itemCategoryId
                                        )) ||
                                      null
                                    }
                                    controlFunc={(e) =>
                                      handleInputChangeTable(
                                        e,
                                        index,
                                        "itemCategoryId",
                                        true
                                      )
                                    }
                                  />
                                </div>
                              ) : keyData.key === "commoditiesName" ? (
                                <div className=" border p-1">
                                  <div className="flex items-center w-full font-bold">
                                    {keyData.title}
                                  </div>
                                  <AutoDropDown
                                    name="itemId"
                                    Class="custom-class"
                                    options={row.itemList || []}
                                    selectedOption={
                                      (row.itemList &&
                                        row.itemList.find(
                                          (opt) => opt.value === row.itemId
                                        )) ||
                                      null
                                    }
                                    content={row.itemId}
                                    controlFunc={(e) =>
                                      handleInputChangeTable(
                                        e,
                                        index,
                                        "itemId",
                                        true
                                      )
                                    }
                                  />
                                </div>
                              ) : keyData.key === "quantity" ? (
                                <div className=" border p-1">
                                  <div className="flex items-center w-full whitespace-nowrap font-bold">
                                    {keyData.title}
                                  </div>
                                  <div
                                    title={`Min Stock: ${row.currentStock || 0
                                      }`}
                                  >
                                    <InputText
                                      type="number"
                                      name="quantity"
                                      value={row.quantity}
                                      content={row.quantity}
                                      controlFunc={(e) => {
                                        const InputText = e.target.value;

                                        if (/^[0-9]*$/.test(InputText)) {
                                          handleInputChangeTable(
                                            e.target,
                                            index,
                                            "quantity"
                                          );
                                        }
                                      }}
                                      controlFuncBlur={(e) => {
                                        const inputValue = e.target.value;

                                        // Validate the value when the user leaves the field
                                        if (
                                          inputValue !== "" &&
                                          parseFloat(inputValue) <
                                          (row.currentStock || 0)
                                        ) {
                                          handleInputChangeTable(
                                            { value: "" },
                                            index,
                                            "quantity"
                                          ); // Clear the value if invalid
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                              ) : keyData.key === "uom" ? (
                                <div className=" border p-1">
                                  <div className="flex items-center w-full whitespace-nowrap font-bold">
                                    {keyData.title}
                                  </div>
                                  <InputText
                                    name="uom"
                                    content={row.uom}
                                    controlFunc={(e) =>
                                      handleInputChangeTable(e, index, "uom")
                                    }
                                  />
                                </div>
                              ) : keyData.key === "rate" ? (
                                <div className=" border p-1">
                                  <div className="flex items-center w-full whitespace-nowrap font-bold">
                                    {keyData.title}
                                  </div>
                                  <InputText
                                    type="number"
                                    name="rate"
                                    // value={row.rate}
                                    content={row.rate}
                                    controlFunc={(e) => {
                                      const InputText = e.target.value;

                                      if (/^[0-9]*$/.test(InputText)) {
                                        handleInputChangeTable(
                                          e.target,
                                          index,
                                          "rate"
                                        );
                                      }
                                    }}
                                  />
                                </div>
                              ) : (
                                <div className="flex border p-1">
                                  <div className="flex basis-1/2 font-bold">
                                    {keyData.title}
                                  </div>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      ))}
                  </div>
                </div>
                <div className="md:hidden">
                  {receiptError && (
                    <div className="text-red-500 text-sm font-medium">
                      {receiptError}
                    </div>
                  )}
                </div>
                <TextArea
                  title="Remarks"
                  name="remarks"
                  placeholder="Remarks"
                  rows={3}
                  maxLength={500}
                  // tabIndex="1"
                  content={formFields.remarks}
                  controlFunc={handleInputChangeForm}
                />
                <div className="flex justify-center mt-6 gap-4">
                  <Buttons
                    addScreenTitle={addScreenTitle}
                    updateScreenTitle={updateScreenTitle}
                    viewSaveButton={false}
                    handleSubmit={handleSubmit}
                    disabledBtn={submitBtnDisabled ? true : false}
                    cancel={cancel}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      )} {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}

      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleReceipt}
      >
        <div>
          <PopUpScreenTitle
            title="Receipts"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />

          <ReceiptMainPopup data={popUpData} data1={popUpDataDD} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          handleSubmit={handleSubmit}
          cancel={cancel}
        />
      </MainPopup>

      <MainPopup
        popUpOpen={popUpViewOpen}
        setpopUpOpen={setPopUpViewOpen}
        Open={showView}
      >
        <div>
          <PopUpScreenTitle
            title="Receipts"
            setpopUpOpen={setPopUpViewOpen}
            viewDetails={popUpViewOpen}
          />

          <Receiptpopup data={receiptRecord} data1={receiptTableData} />
        </div>
        <PopUpButtons cancel={cancel} />
      </MainPopup>
    </MainLayout>
  );
};
export default Receipts;
